import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConnexionComponent } from '../connexion/connexion.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public dialogAdd: MatDialog) { }

  ngOnInit(): void {
  }

  openDialogConnexion(): void {
    let newDialogUpgradeLicence = this.dialogAdd.open(ConnexionComponent, {
      width: '600px',
      // data: {
      //   user: this.emprunteur,
      //   title: ""
      // }
    });

    newDialogUpgradeLicence.afterClosed().subscribe(result => {
      // if (result.maill !== null) {
        // this.emprunteur.email = result.mail;
        // console.log("toto")
      // }
    });
  }

  goToIos(){
    window.open('https://apps.apple.com/fr/app/receipt2go/id1525994349', '_blank');
  }

  goToAndroid(){
    window.open('https://play.google.com/store/apps/details?id=com.yenop.receipt2goAndroid', '_blank');
  }

}
